import { render, staticRenderFns } from "./VLinkForm.vue?vue&type=template&id=31e11d85&"
import script from "./VLinkForm.vue?vue&type=script&lang=js&"
export * from "./VLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports